import { query, proxy_api } from "@core/helpers/graphql";
import { GET_ALL_CATEGORIES, GET_CATEGORIES, GET_CATEGORY_BY_SLUG } from "./_queries";

export const get_category_by_slug_query = async (variables, options = {}) => {
    const { gql, category_search_page_mockup } = options
    const result = await query(gql || GET_CATEGORY_BY_SLUG({ category_search_page_mockup }), variables, options);
    return {
        data: result?.data,
        errors: result?.errors || false,
        status: result?.status || false,
    };
}

export const get_category_by_slug_query_proxy = async (variables, options = {}) => {
    const { gql, category_search_page_mockup, card_model_name } = options

    if (card_model_name == "ProductModel") return await get_category_by_slug_query(variables, options);

    const result = await proxy_api({
        type: 'query',
        gql: gql || GET_CATEGORY_BY_SLUG({ category_search_page_mockup }),
        variables,
        options,
        cacheOptions: {
            name: 'category_by_slug',
            ttl: 60 * 5,
            keys: variables
        }
    });
    return {
        data: result?.data,
        errors: result?.errors || false,
        status: result?.status || false,
    };
}

export const get_categories_query = async (variables, options = {}) => {
    const { gql, category_search_page_mockup } = options
    const result = await query(gql || GET_CATEGORIES({ category_search_page_mockup }), variables, options);
    return {
        data: result?.data,
        errors: result?.errors || false,
        status: result?.status || false,
    };
}

export const get_all_categories_query = async (variables, options = {}) => {
    const { gql, categories_mockup } = options
    const result = await query(gql || GET_ALL_CATEGORIES({ categories_mockup }), variables, options);
    return {
        data: result?.data,
        errors: result?.errors || false,
        status: result?.status || false,
    };
}
